<!-- Spinner -->
<ngx-spinner type="ball-spin-clockwise">
    <p id= "spinnerTxt" class="loading text-white"></p>
</ngx-spinner>

<!-- Tour Step Template -->
<tour-step-template></tour-step-template>

<!-- Central Notifications Component -->
<central-notifications></central-notifications>

<!-- Router -->
<router-outlet></router-outlet>
